import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid'
import FiltersSection from '../../Filters/FiltersSection'
import withStyles from '@material-ui/core/styles/withStyles'
import { Typography } from '@material-ui/core';
import connect from "react-redux/es/connect/connect";
import classNames from 'classnames';
import HourTotalChart from "./HourTotalChart";
import {getRaspaCycleHourUsageStatistics} from "../../../actions/raspaCycleActions";
import HourTotalByTypeChart from "./HourTotalByTypeChart";
import HourTotalByTypePerOperatorChart from "./HourTotalByTypePerOperatorChart";
import HourTotalByTypePerDayChart from "./HourTotalByTypePerDayChart";
import TotalUsagePerDateChart from "./TotalUsagePerDateChart";
import RaspaBuffingStatsPerSaw from "./RaspaBuffingStatsPerSaw";
import RithmPerOperatorChart from "./RithmPerOperatorChart";
import StatCard from "../../../components/StatCard";
import RaspaCycleDistributionOnHourChart from "./RaspaCycleDistributionOnHourChart";
import RaspaCycleDistributionOnHourColumnChart from "./RaspaCycleDistributionOnHourColumnChart";
import RaspaCycleDistributionOnHourStackedChart from "./RaspaCycleDistributionOnHourStackedChart";
import RaspaKPIs from "./RaspaKPIs";
import RaspaCycleDistributionOnHourEnergyChart from "./RaspaCycleDistributionOnHourEnergyChart";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import OSESeriesDHChart from "../../../components/OSESeriesDHChart";

//const stations = [1,2,3,4]

const styles = theme => ({
    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
      marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
      marginBottom: theme.spacing(1) * 5,


    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
      paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
});

class RaspaHourDashboard extends Component {
    constructor(props) {
        super(props);

        this.props.getRaspaCycleHourUsageStatistics();
        this.renderContent = this.renderContent.bind(this);
        this.renderLoadingScreen = this.renderLoadingScreen.bind(this);
        this.onFilterClick = this.onFilterClick.bind(this);
    }

    componentDidUpdate(oldProps, oldState){
        //if (oldProps.filter.)

        // if (JSON.stringify(oldProps.filter) !== JSON.stringify(this.props.filter)) {
        //     this.props.getRaspaCycleHourUsageStatistics();
        // }
    }

    onFilterClick = () => {
        this.props.getRaspaCycleHourUsageStatistics();
    }


    renderLoadingScreen() {
        const { classes } = this.props;
        return (
            <React.Fragment>
                <div align="center">
                    <CircularProgress className={classes.progress} />
                </div>
            </React.Fragment>
        )
    }

    renderContent(){
        const { classes } = this.props;
        return (<Grid container direction="column">
            <Grid container item direction="row" alignItems="stretch" spacing={16}>


                <Grid item xs={12} className={classes.marginBottom}>
                    <RaspaKPIs isLoading={this.props.raspaCycleStatistics.isFetchingRaspaCycleStatistics}  series={this.props.raspaCycleStatistics.hourUsageTotals} seriesPerType={this.props.raspaCycleStatistics.hourUsageTotals} filter={this.props.filter} />
                </Grid>
                {/*<Grid item xs={6}>*/}
                {/*<HourTotalChart series={this.props.raspaCycleStatistics.hourUsageTotals} filter={this.props.filter} />*/}
                {/*</Grid>*/}
                {/*<Grid item xs={6}>*/}
                {/*<RaspaCycleDistributionOnHourChart series={this.props.raspaCycleStatistics.raspaCycleDistributionByDateAndHour} filter={this.props.filter} />*/}
                {/*</Grid>*/}
                {/*<Grid item xs={12}>*/}
                {/*<RaspaCycleDistributionOnHourColumnChart series={this.props.raspaCycleStatistics.raspaCycleDistributionByDateAndHour} filter={this.props.filter} />*/}
                {/*</Grid>*/}




                <Grid item xs={12} className={classes.marginBottomCharts}>
                    <RaspaCycleDistributionOnHourStackedChart series={this.props.raspaCycleStatistics.raspaCycleDistributionByDateAndHour} filter={this.props.filter} />
                </Grid>



                <Grid item xs={6} className={classNames(classes.marginBottom, classes.marginRight)}>
                    <TotalUsagePerDateChart series={this.props.raspaCycleStatistics.totalUsageTimePerTypePerDay} />
                </Grid>

                <Grid item xs={6} className={classNames(classes.marginBottom)}>
                    <RithmPerOperatorChart series={this.props.raspaCycleStatistics.raspaRithmPerOperator} />
                </Grid>


                {/*<Grid item xs={6}>*/}
                {/*<HourTotalByTypeChart series={this.props.raspaCycleStatistics.hourUsageTotals} />*/}
                {/*</Grid>*/}
                <Grid item xs={6} className={classNames(classes.marginBottom, classes.marginRight)}>
                    <HourTotalByTypePerOperatorChart series={this.props.raspaCycleStatistics.hourUsageTotalsPerOperator} />
                </Grid>

                <Grid item xs={6} className={classNames(classes.marginBottom)}>
                    <HourTotalByTypePerDayChart series={this.props.raspaCycleStatistics.totalUsageTimePerTypePerDay} />
                </Grid>

                <Grid item xs={12} className={classes.marginBottomCharts}>
                    <RaspaCycleDistributionOnHourEnergyChart series={this.props.raspaCycleStatistics.raspaCycleDistributionByDateAndHour} filter={this.props.filter} />
                </Grid>

                <Grid item xs={12} className={classes.marginBottom}>
                    <RaspaBuffingStatsPerSaw series={this.props.raspaCycleStatistics.buffingStatsPerSaw} />
                </Grid>

                <Grid item xs={6}>
                </Grid>
            </Grid>
        </Grid>)

    }

    //TODO: reactgridlayout https://github.com/STRML/react-grid-layout
    render() {
        const { classes, isLoading } = this.props;

        console.log(' filter', this.props.filter);

        return (
            <React.Fragment>
                <Grid container direction="column" className={classes.dashboardSection}>
                    <Grid item xs={12}>
                        <FiltersSection showPeriod={true} showBeforePeriod={false} showBenchPeriod={false}
                                        onButtonClick={this.props.getRaspaCycleHourUsageStatistics} loading={this.props.loading} onFilterClick={this.onFilterClick} />
                    </Grid>
                </Grid>
                <Grid item  xs={12} sm={12} lg={12} xl={12}>
                    <Typography variant="h4" align="center" className={classes.sectionTitle}>
                        RASPA - PRODUÇÃO
                    </Typography>
                </Grid>
                { isLoading ? this.renderLoadingScreen() : this.renderContent() }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        raspaCycleStatistics: state.raspaCycles.RaspaCycleStatistics,
        loading : state.raspaCycles.isFetchingRaspaCycleStatistics,
        filter: state.filter,
        fullreducer: state
    }
}


export default connect(mapStateToProps, {getRaspaCycleHourUsageStatistics} ) (withStyles(styles, {withTheme: true})(RaspaHourDashboard));
